import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { OrderForm } from '../components/OrderForm';
import { mockLenders, mockPayoffCompanies, mockInsuranceCompanies, mockAgentContacts, mockTitleCompanies, mockTitleContacts } from '../data/mockData';
import { Order, PayoffCompany, AgentContact, TitleCompany, InsuranceCompany } from '../types';
export function CreateOrder() {
  const navigate = useNavigate();
  const handleSubmit = (orderData: Partial<Order>) => {
    console.log('Creating order:', orderData);
    navigate('/orders');
  };
  const handleCreatePayoffCompany = (company: Omit<PayoffCompany, 'id'>) => {
    console.log('Creating payoff company:', company);
  };
  const handleCreateAgentContact = (contact: Omit<AgentContact, 'id'>) => {
    console.log('Creating agent contact:', contact);
  };
  const handleCreateTitleCompany = (company: Omit<TitleCompany, 'id'>) => {
    console.log('Creating title company:', company);
  };
  const handleCreateInsuranceCompany = (company: Omit<InsuranceCompany, 'id'>) => {
    console.log('Creating insurance company:', company);
  };
  return <div className="max-w-4xl mx-auto space-y-6" data-id="element-387">
      <div className="flex items-center space-x-4" data-id="element-388">
        <Button variant="ghost" onClick={() => navigate('/orders')} className="p-2" data-id="element-389">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-390" />
        </Button>
        <div data-id="element-391">
          <h1 className="text-3xl font-bold text-slate-900" data-id="element-392">
            Create New Order
          </h1>
          <p className="text-slate-600 mt-1" data-id="element-393">
            Fill out the form below to create a new order
          </p>
        </div>
      </div>

      <Card className="p-6" data-id="element-394">
        <OrderForm lenders={mockLenders} payoffCompanies={mockPayoffCompanies} insuranceCompanies={mockInsuranceCompanies} agentContacts={mockAgentContacts} titleCompanies={mockTitleCompanies} titleContacts={mockTitleContacts} onSubmit={handleSubmit} onCancel={() => navigate('/orders')} onCreatePayoffCompany={handleCreatePayoffCompany} onCreateAgentContact={handleCreateAgentContact} onCreateTitleCompany={handleCreateTitleCompany} onCreateInsuranceCompany={handleCreateInsuranceCompany} data-id="element-395" />
      </Card>
    </div>;
}